import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_CUSTOMER_CATEGORIES';

export async function getAllCustomerCategories(
    userToken: string,
    params: string,
    page: number
) {
    try {
         
        
        const response = await axios.get(
             
            `${URL}/customer-categories/?page=${page}&page_size=2000&order=name&active=true${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur de récuperation de la liste des catégories de client',
            error: error
        });
    }
}
